import { baseService } from 'modules/baseService';
import HttpClient from 'services/HttpClient';

const baseUrl = '/notifications';

export const setDailyReminderTime = baseService<number, void>((time) =>
  HttpClient.patch(`${baseUrl}/daily-reminder-time`, { time }),
);
